<template>
<!-- 表单管理 -->
    <div class="el-card pd20">
        <div class="main">
            <!-- list-->
            <div class="el-card pd20">
                <el-table :data="list" show-overflow-tooltip border style="width: 100%">
                    <el-table-column type="index" width="50" label="序号"></el-table-column>
                    <!-- <el-table-column prop="id" label="表单ID" > </el-table-column> -->
                    <el-table-column prop="title" label="标题"></el-table-column>
                    <el-table-column label="操作" width="200">
                        <template slot-scope="scope">
                            <el-button type="primary" size="mini" icon="el-icon-edit" @click="checkData(scope.$index, scope.row)">查看数据</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 添加按钮 -->
            <!-- <el-button type="primary" class="addBtn" size="mini" icon="el-icon-circle-plus"  @click="editChannel()" circle></el-button> -->
            <!-- 分页 -->
            <el-pagination class="pages" 
                :page-sizes="[25, 50, 75, 100]"
                @size-change="handleSizeChange" 
                @current-change="handleCurrentChange" 
                :page-size="pages.size" 
                :current-page="pages.page"
                background 
                layout="sizes,prev, pager, next" 
                :total="pages.count"> 
            </el-pagination>
            <!-- -->
        </div>
        
    </div>
</template>

<script>
import { tableList} from "@/api/career_college";
export default {
    data() {
        return{
            list: [],
            pages: {}
        }
    },
    methods:{
        // 查看数据
        checkData(index,row){
            this.$router.push({
                path:'/main/college_data_list',
                query:{
                    id:row.id
                }
            });
        },
         // 调整每页显示条数
        handleSizeChange(val) {
            this.pages.size = val;
            this.pullData();
        },
        // 触发分页
        handleCurrentChange(val) {
            this.pages.page = val;
            this.pullData();
        },
        pullData(){
            this.$showLoading();
            this.obj = {
                page:this.pages.page?this.pages.page:1,  //页码，默认1
                size:this.pages.size?this.pages.size:25   //每页数量，默认25
            };

            tableList(this.obj).then((data)=>{
                this.list = data.list;
                this.pages = data.pager;

                
                this.$hideLoading();
            }).catch((err)=>{
                this.$hideLoading();
            });
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.main{
  position: relative;
}
.addBtn{
  position: absolute;
  left: 0;
  bottom: 0;
}
.pages{
  text-align: right;
  margin-top: 30px;
}
.pages-box{
    height: 32px;
    margin-top: 30px;
}
.preview{
    width: 300px;
    border-radius: 5px;
}
.box{
    margin-bottom: 20px;
}
.search{
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
}
.search.search-btn{
    flex: 1;
}
.search-gropu{
    flex: 1;
}
.search-gropu.on{
    flex: 1.5;
}
.search-child{
    margin-left: 20px;
    width: 200px;
}
.userinfo{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    img{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 15px;
    }
}
</style>